import { byLabel } from 'module/helpers/comparators/by-label';
import { TranslationKey, useTranslation } from 'module/hooks/use-translation';
import { MultiSelectFieldFilter } from 'module/types/filter-field/filter/multi-select';
import { MultiUserFieldFilter } from 'module/types/filter-field/filter/multi-user';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { snakeCase, startCase } from 'lodash';
import { FC } from 'react';
import styled from 'styled-components';
import { removeTrailingDots } from './utils';

const Text = styled.span`
  max-width: inherit;
  text-wrap: wrap;
`;

const getFilterValues = (
  filter: MultiUserFieldFilter | MultiSelectFieldFilter,
  options,
): string[] => {
  const { type } = filter;

  return type === SelectFilterOperationType.Is ||
    type === SelectFilterOperationType.IsNot ||
    type === SelectFilterOperationType.IsOneOf ||
    type === SelectFilterOperationType.IsNoneOf
    ? (filter as any).value
        .map((x) => (options ?? []).find((u) => u?.value === x)!)
        .sort(byLabel)
        .map((x) => x?.label)
    : [];
};

export const MultiSelectBaseFilterToText: FC<
  React.PropsWithChildren<{
    filter: MultiUserFieldFilter | MultiSelectFieldFilter;
    options;
  }>
> = ({ filter, options }) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <Text>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}{' '}
      {getFilterValues(filter, options).join(', ')}
    </Text>
  );
};
